import { Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import { constant } from 'app/app.constants';


@Injectable()
export class EventBusCardService {
  notificationReceived = new Subject<any>();
  pushReceived = this.notificationReceived.asObservable();

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/event-bus-card.service.ts